import type { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

const SecondaryTopbar = ({ children }: { children: ReactNode }) => {
  if (!children) return null;
  return (
    <div
      className={twMerge(
        'flex flex-wrap sm:flex-nowrap items-center justify-between relative',
        'px-3 lg:px-7 py-2 min-h-8 h-auto sm:h-11 w-full z-10 bg-slate-50 border-b gap-3 sm:gap-0',
        'dark:bg-slate-900 dark:border-b dark:border-slate-800',
      )}
    >
      {children}
    </div>
  );
};

export default SecondaryTopbar;
